import $ from 'jquery';
class NewsSlider {
	constructor($el) {
		this.$el = $el;

		const mediaQuery = window.matchMedia("(min-width: 1200px)");

		let ActiveWrapAround = true;
		let cellAlign = "center";

		const min = 20;
		const max = 35;

		// Clamp number between two values with the following line:
		const clamp = (num, min, max) => Math.min(Math.max(num, min), max);


		if (document.body.clientWidth >= 1183) {
			if (this.$el[0].children.length <= 3) {
				ActiveWrapAround = false;
				this.$el[0].style.margin = "0";
				return Array.from(this.$el[0].children).forEach(child => {
					child.style.width = clamp((90 / this.$el[0].children.length), min, max) + "%";
					child.classList.add('unactive-carousel')
				});
			}
			cellAlign = "left";
		} else if (this.$el[0].children.length <= 2 && document.body.clientWidth >= 450) {
			ActiveWrapAround = false;
		} else if (this.$el[0].children.length <= 1) {
			ActiveWrapAround = false;
		}

		if (mediaQuery.matches) {
			this.options = {
				autoPlay: true,
				pageDots: true,
				wrapAround: ActiveWrapAround,
				prevNextButtons: true,
				freeScroll: true,
				cellSelector: ".carousel-cell",
				cellAlign: cellAlign,
				imagesLoaded: true
			};
		} else {
			this.options = {
				autoPlay: true,
				pageDots: true,
				wrapAround: ActiveWrapAround,
				prevNextButtons: true,
				freeScroll: true,
				cellSelector: ".carousel-cell",
				cellAlign: cellAlign, //center
				imagesLoaded: true
			};
		}

		if (this.$el.length) {
			this._createSlider();
		}
	}

	_createSlider() {
		this.$el.flickity(this.options);
	}
}

export default NewsSlider;